import React from 'react';
import * as PropTypes from 'prop-types';


/**
 * The play store button for downloading the Moblyx Inspect app.
 */
export default function DownloadApp({ className, style }) {
  return (
    <a className={className} style={style} target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.moblyx.minspect&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
      <img style={{ width: '200px' }} alt="Get it on Google Play" src="https://play.google.com/intl/en_gb/badges/images/generic/en_badge_web_generic.png" />
    </a>
  );
}

DownloadApp.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

DownloadApp.defaultProps = {
  className: '',
  style: {},
};
